export class StoreSwitcherDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Don't activate store switcher in the customiser
    if (window.Shopify.designMode) return

    this.setupCountrySelectorPopup = this.setupCountrySelectorPopup.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    const windowCountry = window.localStorage.getItem('userLocation')

    if (this.countryParam !== null) {
      const countryCode = this.countryParam
      window.localStorage.setItem('userLocation', countryCode)

      this.setupCountrySelectorDrawer(countryCode)
    } else if (windowCountry) {
      this.setupCountrySelectorDrawer(windowCountry)
    } else {
      window.BAO.Utils.fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then(res => {
        const countryCode = res.detected_values.country.handle

        this.setupCountrySelectorDrawer(countryCode)

        this.setupCountrySelectorPopup()
      })
    }

    const searchInput = this.externalEls.search.element
    const searchResults = this.externalEls?.searchResults?.element
    const countrySelect = this.externalEls?.countrySelect?.element

    // Show search results when typing
    searchInput.addEventListener('keyup', (event) => {
      const searchTerm = event.target.value
      this.handleSearch(searchTerm)

      if (searchTerm.length > 0) {
        searchResults?.setAttribute('data-visible', 'true')
      } else {
        searchResults?.setAttribute('data-visible', 'false')
      }
    })

    // Show search results when input is focused and has value
    searchInput.addEventListener('focus', (event) => {
      if (event.target.value.length > 0) {
        searchResults?.setAttribute('data-visible', 'true')
      }
    })

    // Handle click outside to close search results
    document.addEventListener('click', this.handleClickOutside)

    // Handle country select change
    if (countrySelect) {
      countrySelect.addEventListener('change', (event) => {
        const selectedValue = event.target.value
        if (selectedValue) {
          window.location.href = selectedValue
        }
      })
    }

    const languageSelects = this.externalEls?.language?.elements
    if (languageSelects) {
      languageSelects.forEach((languageSelect) => {
        languageSelect.addEventListener('change', (event) => {
          const selectedOption = event.target.options[event.target.selectedIndex]
          const domain = languageSelect.getAttribute('data-domain')
          const path = languageSelect.getAttribute('data-path')
          const locale = selectedOption.value
          const currentLocale = languageSelect.getAttribute('data-current-locale')

          this.handleLanguageSelect(domain, path, locale, currentLocale)
        })
      })
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleClickOutside (event) {
    const searchResults = this.externalEls?.searchResults?.element
    const searchInput = this.externalEls?.search?.element

    if (searchResults && searchInput) {
      const isClickInside = searchResults.contains(event.target) || searchInput.contains(event.target)

      if (!isClickInside && searchResults.getAttribute('data-visible') === 'true') {
        searchResults.setAttribute('data-visible', 'false')
      }
    }
  }

  setupCountrySelectorDrawer (countryCode) {
    this.createItemsList(countryCode)
    this.populateCountrySelect(countryCode)
  }

  populateCountrySelect (countryCode) {
    const countrySelect = this.externalEls?.countrySelect?.element
    if (!countrySelect) return

    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency, language } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()

      let languagePath = ''
      if (language !== undefined) {
        languagePath = `/${language}`
      }

      const url = `${this.sites[site].url}${languagePath}${this.dataset.currentUrl}?country=${key}&currency=${currency}`

      const option = document.createElement('option')
      option.value = url
      option.textContent = `${name}`
      if (isCurrentSite) {
        option.selected = true
      }

      countrySelect.appendChild(option)
    })
  }

  setupCountrySelectorPopup () {
    const popup = this.externalEls?.popup?.element
    const closePopup = this.externalEls?.popupClose?.element
    const confirmBtn = this.externalEls?.popupConfirm?.element

    if (!popup) return

    closePopup.addEventListener('click', () => {
      popup.classList.remove('loc-Popup-active')
    })

    confirmBtn.addEventListener('click', () => {
      const paramPrefix = window.location.search ? '&' : '?'
      window.location.href += `${paramPrefix}country=${confirmBtn.dataset.currentCountry}`
    })

    this.externalEls?.popup?.element.classList.add('loc-Popup-active')
  }

  createItemsList (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency, language } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.els.items.element.innerHTML += this.createItemElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
        language,
      )
    })
  }

  createItemElement (code, site, isCurrentSite, country, currency, language) {
    let languagePath = ''
    if (language !== undefined) {
      languagePath = `/${language}`
    }
    return `
      <li class="drw-StoreSelector_Item">
        <a
          class="drw-StoreSelector_Link fz-13_120"
          href="${this.sites[site].url}${languagePath}${this.dataset.currentUrl}?country=${code}&currency=${currency}"
          aria-current="${isCurrentSite ? 'true' : 'false'}"
        >
          <img
            src="https://flagcdn.com/w80/${code.toLowerCase()}.png"
            alt="${country} flag"
            class="drw-StoreSelector_Flag"
            height="20"
            width="27"
          />
          ${country} / ${currency}
        </a>
      </li>
    `
  }

  handleSearch (searchTerm) {
    const items = this.els.items.element.children
    const lowerCaseSearchTerm = searchTerm.toLowerCase()

    Array.from(items).forEach(item => {
      const storeName = item.querySelector('.drw-StoreSelector_Link').textContent.toLowerCase()
      if (storeName.includes(lowerCaseSearchTerm)) {
        item.style.display = ''
      } else {
        item.style.display = 'none'
      }
    })
  }

  handleLanguageSelect (domain, path, locale, currentLocale) {
    if (currentLocale && path.startsWith(`/${currentLocale}`)) {
      path = path.replace(`/${currentLocale}`, '')
    }

    if (locale === 'en') {
      locale = ''
    } else {
      locale = `/${locale}`
    }

    const newUrl = `https://${domain}${locale}${path}`
    window.location.href = newUrl
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'BAO-localization'
  }

  get sites () {
    return {
      EU: {
        url: 'https://www.eu.nadinemerabi.com',
      },
      UK: {
        url: 'https://www.nadinemerabi.com',
      },
      US: {
        url: 'https://us.nadinemerabi.com',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-switcher-drawer')) {
  customElements.define('store-switcher-drawer', StoreSwitcherDrawer)
}
